module.exports = {
  title: "Lingua.community",
  serviceWorker: {
    NEW_VERSION_AVAILABLE: {
      content: "Доступна новая версия!",
    },
    INSTALL_RECOMMENDATION: {
      title: "Установка приложения",
      content:
        "Установите приложение Lingua Community, чтобы пользоваться нашей платформой удобнее",
      iosSteps: `Чтобы установить приложение на ваше устройство, выполните следующие действия:<ol class="mt-4"><li class="mb-2"><div>Нажмите "Поделиться"</div><div><img alt="Шаг 1" class="fill-width" src="/pwa/installation/ios/step1.jpeg"></div><li class="mb-2"><div>Нажмите "Добавить на экран «Домой»"</div><div><img alt="Шаг 2" class="fill-width" src="/pwa/installation/ios/step2.jpeg"></div><li class="mb-2"><div>Нажмите "Добавить"</div><div><img alt="Шаг 3" class="fill-width" src="/pwa/installation/ios/step3.jpeg"></div><li class="mb-2"><div>Найдите приложение на экране «Домой»</div><div><img alt="Шаг 4" class="fill-width" src="/pwa/installation/ios/step4.jpeg"></div></ol>`,
      install: "Установить",
    },
  },
  autoMessages: {
    CONNECT: `
    Здравствуйте!
    Я бы хотел быть на связи с вами.
    `,
    BOOK_LESSON: `
    Здравствуйте!
    Я хотел бы записаться к вам на урок.
    `,
  },
  validators: {
    required: "Это поле обязательно для заполнения",
    minValue: "Минимальное допустимое значение - {value}",
    maxValue: "Максимальное допустимое значение - {value}",
    passwordMustMatch: "Пароли должны совпадать",
    invalidEmail: "Недопустимый адрес электронной почты",
    maxLength: "Поле не должно превышать {length} символов",
    selectAtLeastOne: "Выберите хотя бы один вариант",
    firstName: "Имя обязательно для заполнения",
    lastName: "Фамилия обязательна для заполнения",
    mustSelect: "Вы должны выбрать {length} критерий",
    optionalPrefix: "(доп.)",
    minArrayValue: "Минимальное количество разрешенных опций - {value}",
    maxArrayValue: "Максимальное количество разрешенных опций - {value}",
  },
  errorMessages: {
    LESSON_NOT_FOUND: "Урок не найден",
    "Failed to fetch":
      "У вас проблемы с подключением, пожалуйста, проверьте ваш интернет и попробуйте снова",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL: "Требуется пометить фразу",
    REQUIRED_DRAGGABLE_MARKED_SYMBOL_MIN_1:
      "Требуется пометить как минимум 1 фразу",
    REQUIRED_FIELD_MARKED_SYMBOL: "Требуется пометить фразу",
    REQUIRED_FIELD_MARKED_SYMBOL_MIN_1:
      "Требуется пометить как минимум 1 фразу",
    REQUIRED_SYNONYM_MARKED_SYMBOL: "Требуется пометить фразу-синоним",
    REQUIRED_REAL_SYNONYM_MARKED_SYMBOL: "Требуется пометить настоящий синоним",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL: "Требуется пометить фальшивый синоним",
    SYNONYM_MARKED_SYMBOL_MUST_BE_1: "Требуется пометить ровно 1 фразу-синоним",
    REAL_SYNONYM_MARKED_SYMBOL_MUST_BE_1:
      "Требуется пометить ровно 1 настоящий синоним",
    REQUIRED_FAKE_SYNONYM_MARKED_SYMBOL_MIN_1:
      "Требуется пометить как минимум 1 фальшивый синоним",
    REQUIRED_REAL_PLACE_MARKED_SYMBOL: "Требуется пометить настоящее место",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL: "Требуется пометить фальшивое место",
    REAL_PLACE_MARKED_SYMBOL_MUST_BE_1:
      "Требуется пометить ровно 1 настоящее место",
    REQUIRED_FAKE_PLACE_MARKED_SYMBOL_MIN_1:
      "Требуется пометить как минимум 1 фальшивое место",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL:
      "Требуется пометить правильную/неправильную фразу",
    REQUIRED_CORRECT_OR_WRONG_MARKED_SYMBOL_MIN_1:
      "Требуется пометить как минимум 1 правильную/неправильную фразу",
    USER_EMAIL_ALREADY_CREATED:
      "Пользователь с этим адресом электронной почты уже зарегистрирован",
    INVALID_PERMISSIONS:
      "Ресурс, который вы ищете, в настоящее время недоступен. <br /> Похоже, на ресурсе установлены некоторые настройки конфиденциальности.",
  },
  pages: {
    common: {
      profile: "Профиль",
      balance: "Баланс: <b>${value}</b>",
      visitProfile: "Посетить профиль",
      profileSettings: "Настройки профиля",
      logout: "Выйти",
      message: "Сообщение",
      connect: "Связь",
      joinToConnect: "Присоединиться к связи",
      removeConnection: "Удалить",
      pending: "Ожидание",
      acceptInvitation: "Принять",
      declineInvitation: "Отклонить",
      filters: "Фильтры",
      id: "ID",
      cancel: "Отмена",
      add: "Добавить",
      share: "Поделиться",
      repost: "Репост",
      repostWithYourThoughts: "Репост с вашими мыслями",
      send: "Отправить",
      submit: "Отправить",
      save: "Сохранить",
      unsave: "Удалить из сохранённого",
      like: "Нравится",
      unlike: "Не нравится",
      comment: "Комментарий",
      likes: "Лайк(и)",
      comments: "Комментарий(и)",
      login: "Войти",
      signUp: "Зарегистрироваться",
      create: "Создать",
      update: "Обновить",
      edit: "Редактировать",
      reset: "Сбросить",
      close: "Закрыть",
      delete: "Удалить",
      loading: "Загрузка",
      loadMore: "Загрузить еще",
      oops: "Упс",
      reload: "Перезагрузить",
      copied: "Скопировано",
      searchAnyPerson: "Искать любого человека",
      typeAnyPersonsName: "Введите имя любого человека",
      noMatchingUsers: "Нет подходящих пользователей",
      searchForUsers: "Поиск пользователей",
      seeAllResults: "Посмотреть все результаты",
      search: "Поиск",
      show: "Показать",
      showMore: "показать больше",
      showLess: "показать меньше",
      untitled: "Без названия",
      unnamed: "Без имени",
      copyLink: "Копировать ссылку",
      preview: "Пред. просмотр",
      moveUp: "Переместить вверх",
      moveDown: "Переместить вниз",
      fork: "Сохранить",
      unfork: "Удалить",
      actions: "Действия",
      tabs: {
        main: "Главное",
        home: "Домой",
        myNetwork: "Моё сообщество",
        schedule: "Расписание",
        messages: "Сообщения",
        materials: "Материалы",
      },
      download: "Скачать",
      uploading: "Выгрузка...",
      next: "След.",
      done: "Готово",
      new: "Новый",
      rename: "Редактировать",
      back: "Назад",
      category: {
        saved: "Сохранено",
        categories: "Категории",
        title: "Категория",
        newTitle: "Новая категория",
        editTitle: "Редактировать категорию",
        addCategory: "Добавить категорию",
        form: {
          title: "Название",
        },
      },
      linkToShare: "Ссылка для копирования",
      select: "Выбрать",
      selected: "Выбрано",
      nItemsSelected: "{value} элемент(ов) выбрано",
      signIn: "Войти",
      apply: "Применить",
      lessonBoards: "Доски",
      notifications: "Уведомления",
      more: "Ещё",
    },
    feed: {
      form: {
        content: {
          placeholder: "Напишите, что у вас на уме...",
        },
      },
      noFeedsFound: "Ленты не найдены",
      post: "Опубликовать",
      photoOrVideo: "Фото / Видео",
      addMaterial: "Добавить материал",
      repostDescription: {
        repost: "Мгновенно разместить пост в ленте других пользователей",
        repostWithYourThoughts: "Создать новый пост на основе текущего",
      },
      copyLinkToPost: "Скопировать ссылку на пост",
      selectUsersToSend: "Выберите пользователя(ей) для отправки поста",
    },
    comment: {
      form: {
        content: {
          commentPlaceholder: "Добавить комментарий...",
          replyPlaceholder: "Добавить ответ...",
        },
      },
      comment: "Комментарий",
      noCommentsAddedYet: "Комментарии не добавлены",
      commentNow: "Оставить комментарий",
      loadMoreComments: "Загрузить больше комментариев",
      reply: "Ответить",
      replyingTo: "Ответ на:",
      viewMoreReplies: "Посмотреть больше ответов ({value})",
      viewReplies: "Посмотреть ответы ({value})",
    },
    mediaEditor: {
      title: "Редактор",
      upload: {
        selectAFileToBegin: "Выберите файл, чтобы начать",
        sharePhotoOrVideoInYourPost: "Добавьте фото или видео в свой пост",
        uploadFromYourDevice: "Загрузить с устройства",
        dragYourFilesHere: "Перетащите файлы сюда",
        dropYourFileHere: "Переместите файл сюда",
        dropYourFilesHere: "Переместите файлы сюда",
      },
    },
    home: {
      leftContainerDescription:
        "Место, где студенты и учителя со всего мира достигают высоких результатов, работая без посредников",
      aboutUs: "О нас",
      iAmAStudent: "Я студент",
      iAmATeacher: "Я учитель",
    },
    promo: {
      student: {
        title: "Более 100 профессиональных учителей, которым доверяют люди",
        description:
          "Студенты выставляют оценки учителям за эффективность обучения. На основе этих оценок мы рекомендуем вам лучших учителей",
        howEffectiveWasLesson: "На сколько эффективен был ваш урок?",
        submitGrade: "Подтвердить оценку",
        filterData: {
          title: "Ответьте на вопросы, и мы подберем идеального учителя",
          languageYouWantToLearn: "Язык, который вы хотите изучить",
          chooseLanguage: "Выберите язык",
          priceForLesson: "Цена за урок",
          chooseQuality:
            "Выберите качество, которое вы цените больше всего в своем учителе",
        },
        showResult: "Показать результат",
        showMore: "Показать больше ({value})",
      },
    },
    modules: {
      voiceRecorder: {
        title: "Запись голоса",
      },
      cameraInitialization: {
        title: "Инициализация камеры",
      },
      cameraSettings: {
        title: "Настройки камеры",
        audio: "Аудио",
        video: "Видео",
        microphone: "Микрофон",
        camera: "Камера",
        preview: "Предварительный просмотр",
      },
    },
    camera: {
      cameraNotVisibleDescription:
        "Если вы не видите себя, измените устройство ввода камеры в настройках",
      cameraSettings: "Настройки камеры",
    },
    skills: {
      languages: {
        english: {
          title: "Онлайн-репетиторы по английскому для частных уроков",
          description:
            "Найдите идеального репетитора по английскому, чтобы повысить свой деловой английский, подготовиться к экзаменам или стать лучше в повседневном общении! LiveXP насчитывает множество замечательных репетиторов. Откройте для себя онлайн-репетитора по английскому, который сможет сделать изучение интересным и продуктивным. LiveXP - это место, где полно частных репетиторов по английскому, которые знают, как помочь вам достичь заметных результатов. Думаете, с чего начать? Просматривайте репетиторов Realteacher онлайн по английскому, проходите пробное занятие, оцените, как вам это понравится, и начните учиться регулярно!",
        },
      },
      userCard: {
        aboutMe: "Обо мне",
        rated: "Оценено",
        notEnoughDataToShow: "Недостаточно данных для показа",
        lessons: "Уроки",
        price: "Цена",
        quickLook: "Просмотр",
        visitProfile: "Посетить профиль",
        bookLesson: "Забронировать урок",
        viewSchedule: "Расписание",
        reviews: "Отзывы",
        yourPhone: "Ваш номер телефона",
        phoneHint:
          'Отправляя свои личные данные, вы соглашаетесь с <a href="/terms-of-service" target="_blank">условиями использования</a>. ',
        exchangeContacts: "Обменяться контактами",
        exchangeContactsModal: {
          informationSentSuccessfully:
            "Ваша контактная информация была отправлена учителю",
          callYourself: "Не хотите ждать? Позвоните сами.",
        },
        review: {
          numberOfLessons: `{value} урок(ов)`,
          noReviewsFound: "Отзывов не найдено",
          hadNLessonsTogether:
            "не было уроков вместе | был {value} урок вместе | было {value} уроков вместе",
        },
        perHour: "ч.",
      },
      filters: {
        price: "Цена",
        interests: "Интересы",
        updateResults: "Обновить результаты",
        speaks: "Говорит на",
        specialities: "Специализации",
        textbooks: "Учебники",
        criteria: "Критерии",
        lessonPrice: "Цена урока",
        studyObjectives: "Цели обучения",
        form: {
          query: {
            label: "Имя",
            placeholder: "Введите имя учителя...",
          },
        },
      },
      noInstructorsFound:
        "По вашим критериям фильтрации инструкторы не найдены",
    },
    search: {
      title: "Поиск",
      tabs: {
        all: "Все",
        instructors: "Инструкторы",
        students: "Студенты",
      },
      filters: {
        interests: {
          label: "Интересы",
          placeholder: "Введите название интереса",
        },
        teaches: {
          label: "Преподаёт",
          placeholder: "Введите название языка",
        },
        speaks: {
          label: "Говорит на",
          placeholder: "Введите название языка",
        },
        specialities: {
          label: "Специализации",
          placeholder: "Введите название специализации",
        },
        textbooks: {
          label: "Учебники",
          placeholder: "Введите название учебника",
        },
      },
    },
    signIn: {
      title: "Вход",
      yourEmail: "Ваш email",
      password: "Пароль",
      forgotYourPassword: "Забыли пароль?",
      signUpTitle: "Новый пользователь Lingua Community?",
      signUp: "Зарегистрироваться",
      submit: "Войти",
    },
    signUp: {
      title: "Регистрация",
      header: "Выберите тип аккаунта, который хотите создать",
      signInTitle: "Уже есть аккаунт?",
      signIn: "Войти",
      student: "Студент",
      instructor: "Учитель",
      form: {
        email: {
          label: "Email",
          placeholder: "Например: example@mail.com",
        },
      },
    },
    restorePassword: {
      title: "Восстановление пароля",
      form: {
        email: {
          label: "Email",
          placeholder: "Например: example@mail.com",
        },
        newPassword: {
          label: "Новый пароль",
          placeholder: "Введите ваш новый пароль",
        },
      },
      submit: "Восстановить",
      rememberPasswordTitle: "Вспомнили пароль?",
      otpDescription:
        "Пожалуйста, введите 6-значный код, который мы отправили на ваш email",
      newPasswordDescription: "Пожалуйста, введите ваш новый пароль",
      successDescription:
        "Ваш пароль успешно изменен, пожалуйста, войдите с новым паролем",
      signIn: "Войти",
    },
    login: {
      title: "Войти",
      yourEmail: "Ваш email",
      password: "Пароль",
      forgotYourPassword: "Забыли пароль?",
      register: "Регистрация",
      submit: "Войти",
    },
    registration: {
      registerAs: "Зарегистрироваться как",
      student: "Студент",
      teacher: "Учитель",
      signUp: "Зарегистрироваться",
      login: "Войти",
      speak: "Говорит на:",
      teach: "Преподает:",
      learn: "Изучает:",
      criteria: "Критерии:",
      specialities: "Специализации:",
      textbooks: "Учебники:",
      teachLabel: "На каком языке вы будете преподавать?",
      speakLabel: "На каких языках вы говорите?",
      learnLabel: "На каком языке вы будете учиться?",
      criteriaLabel: "Выберите критерии для учителя",
      user: {
        youRegisteredSuccessfully:
          "Вы успешно зарегистрированы, пожалуйста, следуйте инструкциям, отправленным по электронной почте.",
        specialities: {
          learnBasics: "Основы",
          talkWithPeople: "Общение с людьми",
          forKids: "Для детей",
          improveProficiency: "Улучшение владения языком",
          doBusiness: "Деловое общение",
          prepareForExam: "Подготовка к экзаменам",
        },
        studentReviewQuestions: {
          structure: {
            title: "Структура",
            shortTitle: "Структура",
            description:
              "Связаны ли занятия? Например, на первом уроке вы освоили грамматику модального глагола «can» (I cannot help you). На следующем уроке - present continuous (I am watching TV). Наконец, вы комбинируете обе темы, составляя предложения вроде “I cannot help you because I am watching TV”. Таким образом, структура - это нечто большее, чем простое повторение. Структура - это когда предыдущая грамматика/лексика переплетается с новой темой, в результате чего у студента не возникает пробелов в знаниях.",
            optionsDescription:
              "1 – изучили тему и забыли ее навсегда. <br /> 5 – каждая новая тема объединяет новую грамматику/лексику с ранее изученной",
          },
          punctuality: {
            title: "Пунктуальность",
            shortTitle: "Пунктуальность",
            description:
              "В начале курса вы и ваш учитель заключили договор о расписании. Вы могли договориться встречаться регулярно или иметь гибкое расписание. Вы также могли договориться о политике отмены занятий. Независимо от того, какое у вас расписание, важно, чтобы обе стороны четко понимали и следовали ему.",
            optionsDescription:
              "Поставьте 1, если у вас нет четкого соглашения или понимания политики вашего учителя относительно расписания или/и вы крайне недовольны пунктуальностью вашего учителя. <br/> Поставьте 5, если, в целом, учитель следит за расписанием и не нарушает политику отмены занятий.",
          },
          capability: {
            title: "Доказанная компетентность",
            shortTitle: "Компетентность",
            description:
              "Насколько хорошо учитель знает предмет? Мы считаем, что, в общем, хороший учитель должен знать немного больше, чем книги/материалы, которые он или она использует во время урока. В противном случае, вы могли бы найти те же материалы в интернете и изучить их независимо с тем же успехом.",
            optionsDescription:
              "1 - Я лучше учусь самостоятельно <br/> 2 - учитель в некоторой степени помогает <br/> 3 - если учитель хорошо владеет материалом и может ответить на почти все вопросы <br/> 4 - за предоставление дополнительной информации, не упомянутой в книге (исключения из правил/различные значения одного и того же слова) <br/> 5 - мой учитель делится конкретными культурными аспектами поведения и использования языка или/и может обрабатывать некоторые языковые странности.",
          },
          skills: {
            title: "Развитие навыков",
            shortTitle: "Навыки",
            description:
              "К концу урока вы ушли с пустыми руками или приобрели какие-то знания/навыки? Иными словами, провели ли вы время зря или был ли урок полезен? Результат может быть небольшим, но измеримым, приближая вас к достижению большей цели.",
            optionsDescription:
              "Поставьте 1, если вы провели время зря и сомневаетесь, что когда-либо получите пользу от этого учителя. <br/> Поставьте 5, если вы определенно приобрели различные навыки на каждом уроке, и все эти навыки взаимосвязаны друг с другом, постепенно приближая вас к большему результату",
          },
          practice: {
            title: "Практика",
            shortTitle: "Практика",
            description:
              "На каком языке больше всего говорится во время урока: иностранный или родной?",
            optionsDescription:
              "1 – большую часть времени мы говорим на родном языке <br/> 5 – всё время мы говорим только на иностранном языке",
          },
          responsibility: {
            title: "Ответственность",
            shortTitle: "Ответственность",
            description:
              "Принимает ли учитель на свой счет ваше неудачное или успешное выполнение задания?",
            optionsDescription:
              "1 – учитель предпочитает не замечать мои трудности (если они есть): методика прекрасна, если результаты плохие, учитель намекает на мою единоличную ответственность <br/> 5 – если результаты плохие, мой учитель беспокоится и приспосабливает методику",
          },
          independence: {
            title: "Самостоятельность и мышление",
            shortTitle: "Самостоятельность",
            description:
              "Как учитель реагирует на ваши ошибки? Дает ли он/она вам сразу правильный ответ или дает вам шанс решить проблему самостоятельно?",
            optionsDescription:
              "1 – сразу исправляет меня (слишком много материала, слишком мало времени) <br/> 5 – даёт подсказки, но никогда не торопит с правильным ответом, хочет, чтобы я сам/сама разобрался/разобралась",
          },
          allSkills: {
            title: "Развивает ли учитель все 5 навыков?",
            shortTitle: "Все навыки",
            description:
              "Идеально, на каждом уроке хороший учитель одинаково обращает внимание на развитие 5 языковых навыков: слушание, чтение, разговор, письмо, грамматика.",
            optionsDescription:
              "1 - учитель сосредоточен только на одном из этих навыков, например, ваш учитель обучал только грамматике <br /> 5. - учитель развивает все 5 навыков",
          },
          timeManagement: {
            title: "Управление временем",
            shortTitle: "Время",
            description:
              "Эффективно ли используется время на уроке или оно тратится впустую?",
            optionsDescription:
              "1 – значительное количество времени тратится на то, что могло бы быть сделано до начала урока (загрузка/выгрузка файлов, проверка посещаемости, домашнее задание, поиск информации и т. д.) <br /> 5 – я получаю пользу от каждой минуты урока",
          },
          listeningToStudent: {
            title: "Внимание к студенту",
            shortTitle: "Студентоориентированность",
            description:
              "Кто более активен во время урока: вы или ваш учитель? Является ли ваш учитель хорошим слушателем?",
            optionsDescription:
              "1 – Учитель никогда не дает мне шанса высказаться <br /> 5 – Большую часть времени учитель внимательно слушает, что я имею сказать",
          },
          approach: {
            title: "Подход",
            shortTitle: "Подход",
            description:
              "Некоторым нравятся авторитарные учителя. Другим нравятся учителя с демократическим темпераментом. Нашли ли ваш учитель правильный подход в общении с вами, который помогает вам извлечь максимальную пользу из уроков?",
            optionsDescription:
              "1 – Я бы хотел(а), чтобы учитель был мягче/строже по отношению ко мне <br /> 2 – Учитель нашел лучший подход ко мне",
          },
        },
        userInterestGroup: {
          healthSport: {
            title: "Здоровье и спорт",
          },
          goingOutEntertainment: {
            title: "Выход и развлечения",
          },
          hobbiesEducation: {
            title: "Хобби и образование",
          },
        },
        userInterest: {
          running: {
            title: "Бег",
          },
          workout: {
            title: "Тренировка",
          },
          volleyball: {
            title: "Волейбол",
          },
          cycling: {
            title: "Велоспорт",
          },
          chess: {
            title: "Шахматы",
          },
          martialArts: {
            title: "Боевые искусства",
          },
          basketball: {
            title: "Баскетбол",
          },
          football: {
            title: "Футбол",
          },
          hockey: {
            title: "Хоккей",
          },
          swimming: {
            title: "Плавание",
          },
          diving: {
            title: "Дайвинг",
          },
          extremeSports: {
            title: "Экстремальные виды спорта",
          },
          formula1: {
            title: "Формула 1",
          },
          meditation: {
            title: "Медитация",
          },
          yoga: {
            title: "Йога",
          },
          filmTv: {
            title: "Кино и ТВ",
          },
          theatre: {
            title: "Театр",
          },
          eatingOut: {
            title: "Посещение ресторанов",
          },
          museums: {
            title: "Музеи",
          },
          concerts: {
            title: "Концерты",
          },
          shopping: {
            title: "Шоппинг",
          },
          gaming: {
            title: "Игры",
          },
          boardGames: {
            title: "Настольные игры",
          },
          traveling: {
            title: "Путешествия",
          },
          hiking: {
            title: "Пешие прогулки",
          },
          humor: {
            title: "Юмор",
          },
          business: {
            title: "Бизнес",
          },
          finance: {
            title: "Финансы",
          },
          management: {
            title: "Управление",
          },
          music: {
            title: "Музыка",
          },
          space: {
            title: "Космос",
          },
          history: {
            title: "История",
          },
          pets: {
            title: "Домашние животные",
          },
          dancing: {
            title: "Танцы",
          },
          photography: {
            title: "Фотография",
          },
          singing: {
            title: "Пение",
          },
          arts: {
            title: "Искусство",
          },
          cars: {
            title: "Автомобили",
          },
          motorcycles: {
            title: "Мотоциклы",
          },
          cooking: {
            title: "Кулинария",
          },
          architecture: {
            title: "Архитектура",
          },
          reading: {
            title: "Чтение",
          },
          science: {
            title: "Наука",
          },
          psychology: {
            title: "Психология",
          },
          ecology: {
            title: "Экология",
          },
          technologies: {
            title: "Технологии",
          },
          fashion: {
            title: "Мода",
          },
          politics: {
            title: "Политика",
          },
          writing: {
            title: "Писательство",
          },
          design: {
            title: "Дизайн",
          },
          philosophy: {
            title: "Философия",
          },
          medicine: {
            title: "Медицина",
          },
          celebrities: {
            title: "Знаменитости",
          },
          volunteering: {
            title: "Волонтерство",
          },
          news: {
            title: "Новости",
          },
          personalGrowth: {
            title: "Личностный рост",
          },
        },
        language: {
          english: {
            title: "Английский",
          },
          russian: {
            title: "Русский",
          },
          kyrgyz: {
            title: "Киргизский",
          },
          kazakh: {
            title: "Казахский",
          },
          uzbek: {
            title: "Узбекский",
          },
          turkmen: {
            title: "Туркменский",
          },
          armenian: {
            title: "Армянский",
          },
        },
      },
    },
    passwordRecovery: {
      title: "Восстановление пароля",
      enterYourEmail: "Введите свой адрес электронной почты",
      rememberYourPassword: "Помните свой пароль?",
      submit: "Отправить",
      instructionDescription:
        "Инструкция по восстановлению пароля была отправлена на ваш адрес электронной почты, проверьте свою почту",
      goToLoginScreen: "Перейти на экран входа",
    },
    passwordRecoveryConfirmation: {
      title: "Подтверждение восстановления пароля",
      invalidResetTokenDescription:
        "Недействительный токен сброса. Пожалуйста, попробуйте восстановить свой пароль снова",
      goToPasswordRecoveryScreen: "Перейти на экран восстановления пароля",
      enterNewPassword: "Введите новый пароль",
      confirmYourNewPassword: "Подтвердите ваш новый пароль",
      submit: "Изменить пароль",
      yourPasswordSuccessfullyChanged: "Ваш пароль успешно изменен",
      goToLoginScreen: "Перейти на экран входа",
    },
    profile: {
      main: "Главная",
      feed: "Лента",
      messages: "Сообщения",
      notifications: "Уведомления",
      connections: "Связи",
      myConnections: "Мои связи",
      activityHistory: "История активности",
      schedule: "Расписание",
      myMaterials: "Мои материалы",
      savedMaterials: "Сохраненные материалы",
      lessonsHistory: "История уроков",
      quizzesHistory: "История викторин",
      detalization: "Детализация баланса",
      profileSettings: "Настройки профиля",
    },
    main: {
      endOfActivities: "Конец активностей",
      noActivities: "No activities",
      previewAlert: {
        title: "Ищете предварительный просмотр вашего профиля?",
        description:
          "Вы можете найти предварительный просмотр вашего профиля, нажав на кнопку ниже",
        button: "Мой профиль",
      },
    },
    myConnections: {
      networkManagement: "Управление связями",
      invitations: "Приглашения",
      myInvitations: "Мои приглашения",
      myConnections: "Мои связи",
      userConnections: "Связи пользователя",
      noConnectionsYet: "У вас пока нет связей",
      noConnectionFoundForYourRequest: "По вашему запросу связей не найдено",
      pendingSharedContacts: "Ожидающие общие контакты",
      noPendingSharedContacts: "Нет ожидающих общих контактов",
      markAsRead: "Отметить как прочитанное",
      manageSharedContacts: "Управление общими контактами",

      pendingInvitations: "Ожидающие приглашения",
      manageInvitations: "Управлять приглашениями",
      manageMyConnections: "Управлять моими связями",
      noPendingInvitations: "Нет ожидающих приглашений",
    },
    userConnections: {
      title: "Связи пользователя",
    },
    logout: {
      loggingOut: "Выход из системы...",
    },
    detalization: {
      title: "Детализация баланса",
      dateRange: "Диапазон дат",
      type: "Тип",
      createdAt: "Создано",
      in: "В",
      out: "Из",
      balanceBefore: "Баланс до",
      balanceAfter: "Баланс после",
      sum: "Сумма",
      noHistoryFound: "Транзакций не найдено",
    },
    activityHistory: {
      title: "История активности",
      groupedItemTitle: {
        today: "Сегодня",
        yesterday: "Вчера",
        thisWeek: "На этой неделе",
        thisMonth: "В этом месяце",
        thisYear: "В этом году",
        earlier: "Ранее",
      },
      createdLesson: "Создан урок",
      scheduledLesson: "Запланирован урок",
      startedLesson: "Начат урок",
      with: "с",
      createdQuiz: "Создана викторина",
      finishedQuiz: "Завершена викторина",
      and: "и",
    },
    notifications: {
      title: "Уведомления",
      tabs: {
        All: "Все",
        Lesson: "Урок",
        Other: "Другие",
      },
      endOfNotifications: "Конец уведомлений",
      noNotifications: "Вы еще не получили уведомлений",
    },
    materials: {
      materials: "Материалы",
      tabs: {
        lessons: "Уроки",
        quizzes: "Викторины",
        fileManager: "Файловый менеджер",
      },
      savedMaterials: "Сохраненные материалы",
      author: "Автор",
      whiteboard: "Доска",
      myMaterials: "Мои материалы",
      title: "Название",
      createdAt: "Создано",
      actions: "Действия",
      details: "Подробности",
      creating: "Создание",
      updating: "Обновление",
      choose: "Выбрать",
      attachmentDeletionConfirmation:
        "Вы уверены, что хотите удалить это вложение?",
      audioDeletionConfirmation: "Вы уверены, что хотите удалить это аудио?",
      description: "Описание",
      notes: "Заметки",
      mainInfo: "Основная информация",
      audio: "Аудио",
      attachments: "Вложения",
      vocabulary: "Словарь",
      asVocabulary: "Использовать как словарь",
      itemsPerPage: "Упражнений на странице",
      points: "Баллы",
      user: "Пользователь",
      nonRegisteredUser: "Незарегистрированный пользователь",
      nonRegisteredUserTelNumber: "Телефон незарегистрированного пользователя",
      backToMain: "Вернуться на главную",
      backToLessons: "Вернуться к урокам",
      lesson: {
        title: "Урок",
        tabs: {
          main: {
            title: "Основной",
          },
          attachments: {
            title: "Вложения",
            tabs: {
              audio: "Аудио",
              documents: "Документы",
              "board-documents": "Документы для доски",
            },
          },
          exercises: {
            title: "Упражнения",
            tabs: {
              vocabulary: "Словарь",
              exercises: "Упражнения",
            },
          },
          whiteboard: {
            title: "Доска",
          },
        },
        form: {
          title: {
            label: "Заголовок",
          },
          category: {
            label: "Категория",
          },
        },
        sharingSettings: {
          title: "Настройки общего доступа",
        },
      },
      lessons: {
        all: "Все",
        owned: "Собственные",
        forked: "Сохраненные",
        lessonsList: "Список уроков",
        lessons: "Уроки",
        duration: "Продолжительность",
        myLessons: "Мои уроки",
        newLesson: "Новый урок",
        deletionConfirmation: "Вы уверены, что хотите удалить этот урок?",
        filters: "Фильтры",
        authorizeToAccessBoard:
          "Доска недоступна для незарегистрированных пользователей. Чтобы получить доступ к доске, пожалуйста, войдите в систему.",
        noLessonsFound: "Уроков не найдено",
        noDescriptionAddedYet: "Описание к упражнению не добавлено",
        addDescription: "Добавить описание",
        editDescription: "Редактировать описание",
      },
      quiz: {
        title: "Викторина",
        exercisesPerPageHint:
          "0 означает, что все упражнения будут на одной странице",
        tabs: {
          edit: {
            title: "Редактировать",
          },
          main: {
            title: "Главное",
          },
          history: {
            title: "История",
          },
        },
        types: {
          exercise: {
            title: "Упражнение",
          },
          vocabulary: {
            title: "Словарь",
          },
        },
        form: {
          title: {
            label: "Заголовок",
          },
          category: {
            label: "Категория",
          },
        },
        sharingSettings: {
          title: "Настройки общего доступа",
        },
        additionalSettings: {
          title: "Дополнительные настройки",
        },
      },
      quizzes: {
        all: "Все",
        owned: "Собственные",
        forked: "Сохраненные",
        quizzesList: "Список викторин",
        details: "Подробно",
        backToQuiz: "Вернуться к викторине",
        backToHistory: "Вернуться к истории",
        numberOfExercises: "Количество упражнений",
        maxPoints: "Максимальные баллы",
        quizzes: "Викторины",
        myQuizzes: "Мои викторины",
        history: "История",
        linkedQuizzes: "Связанные викторины",
        linkedVocabulary: "Связанный словарь",
        newQuiz: "Новая викторина",
        linking: "Связывание",
        quiz: "викторина",
        quizUF: "Викторина",
        vocabulary: "словарь",
        deletionConfirmation: "Вы уверены, что хотите удалить эту викторину?",
        unlinkConfirmation:
          "Вы уверены, что хотите разорвать связь с этой викториной?",
        navigation: "НАВИГАЦИЯ",
        filters: "Фильтры",
        student: "Студент",
        setFlag: "Установить флаг",
        unsetFlag: "Снять флаг",
        submitConfirmation: "Вы уверены, что хотите отправить эту викторину?",
        noAnswerExercises: "У вас есть незавершенные упражнения",
        weAreSorryQuizNotFound: "Извините, викторина не найдена :(",
        nonRegistered: {
          title: "Пожалуйста, предоставьте вашу информацию",
          fullName: "Полное имя",
          telNumber: "Номер телефона",
        },
        allUsers: "Все пользователи",
        registeredUsers: "Зарегистрированные пользователи",
        nonRegisteredUsers: "Незарегистрированные пользователи",
        self: "Свои",
        noDescriptionAddedYet: "Описание теста еще не добавлено",
        addDescription: "Добавить описание",
        editDescription: "Редактировать описание",
        editAdditionalSettings: "Редактировать дополнительные настройки",
        authorizeToAccessHistory:
          "История недоступна, чтобы сохранить результаты, пожалуйста, войдите в систему.",
        noQuizzesFound: "Тестов не найдено",
        noQuizHistoriesFound: "Историй выполнения не найдено",
      },
      exercises: {
        exercises: "Упражнения",
        exercise: "Упражнение",
        noAnyExercises: "Нет упражнений",
        noAnyVocabulary: "Нет словаря",
        noAnswer: "Нет ответа",
        detailsAreNotAvailable:
          "Подробности недоступны, так как автор этого упражнения изменил его после вашей отправки текущей викторины.",
        types: {
          dragTheWords: {
            title: "Перетащить слова",
            adminDescription: "Описание администратора для перетаскивания слов",
            studentDescription: "Описание студента для перетаскивания слов",
            draggable: "Перетаскиваемое",
            markSelected: "Отметить выбранное как перетаскиваемое",
            unmarkSelected: "Снять отметку",
          },
          dragTheWordsImage: {
            title: "Перетащите Слова К Изображению",
            adminDescription: "Описание для администратора: перетащите слова",
            studentDescription: "Описание для ученика: перетащите слова",
            draggable: "Перетаскиваемый",
            markSelected: "Отметить выбранное как перетаскиваемое",
            unmarkSelected: "Снять отметку с выбранного",
          },
          fillInTheBlanks: {
            title: "Заполнить пропуски",
            adminDescription:
              "Описание администратора для заполнения пропусков",
            studentDescription: "Описание студента для заполнения пропусков",
            or: "Или",
            anyChar: "Любой символ",
            anyText: "Любой текст",
            addAnotherOption: "Добавить другой вариант",
            markSelected: "Отметить выбранное как поле",
            unmarkSelected: "Снять отметку",
            field: "Поле",
          },
          fillInTheBlanksImage: {
            title: "Заполните Пропуски в Изображении",
            adminDescription: "Описание для администратора: заполните пропуски",
            studentDescription: "Описание для ученика: заполните пропуски",
            or: "Или",
            anyChar: "Любой символ",
            anyText: "Любой текст",
            addAnotherOption: "Добавить еще один вариант",
            markSelected: "Отметить выбранное как поле",
            unmarkSelected: "Снять отметку с выбранного",
            field: "Поле",
          },

          findSynonym: {
            title: "Найти синоним",
            adminDescription: "Описание администратора для поиска синонима",
            studentDescription: "Описание студента для поиска синонима",
            markMainSynonymSelected: "Отметить выбранное как основной синоним",
            markRealSynonymSelected:
              "Отметить выбранное как реальный синоним для основного",
            markFakeSynonymSelected:
              "Отметить выбранное как фиктивный синоним для основного",
            unmarkSelected: "Снять отметку",
            synonym: "Синоним",
            real: "Реальный",
            fake: "Фиктивный",
          },
          findThePlace: {
            title: "Найти место",
            adminDescription: "Описание администратора для поиска места",
            studentDescription: "Описание студента для поиска места",
            real: "Реальное",
            fake: "Фиктивное",
            insertFakePlace: "Вставить фиктивное место",
            markRealPlaceSelected: "Отметить выбранное как реальное место",
            unmarkSelected: "Снять отметку",
          },
          markTheWords: {
            title: "Пометить слова",
            adminDescription: "Описание администратора для пометки слов",
            studentDescription: "Описание студента для пометки слов",
            correct: "Правильный",
            wrong: "Неправильный",
            markCorrectSelected: "Отметить выбранное как правильный ответ",
            markWrongSelected: "Отметить выбранное как неправильный ответ",
            unmarkSelected: "Снять отметку",
          },
          multipleChoice: {
            title: "Множественный выбор",
            adminDescription:
              "Описание администратора для множественного выбора",
            studentDescription: "Описание студента для множественного выбора",
          },
          singleChoice: {
            title: "Одиночный выбор",
            adminDescription: "Описание администратора для одиночного выбора",
            studentDescription: "Описание студента для одиночного выбора",
          },
          trueFalse: {
            title: "Верно или Неверно",
            adminDescription: "Описание администратора для правда или ложь",
            studentDescription: "Описание студента для правда или ложь",
          },
        },
        true: "Верно",
        false: "Неверно",
        answer: "Ответ",
        title: "Название",
        type: "Тип",
        description: "Описание",
        text: "Текст",
        chooseImage: "Выберите изображение",
        descriptionAudio: "Аудио описание",
        answerAudio: "Аудио ответ",
        attachedAudio: "Прикрепленное аудио",
        audioHint:
          "Ниже отмеченные опции будут работать, если количество упражнений на странице в викторине равно 1",
        hideAudio: "Скрыть аудио",
        audioAutoplay: "Автовоспроизведение",
        answerOptions: "Варианты ответов",
        selectCorrectAnswers: "Выберите правильные ответы",
        selectCorrectAnswer: "Выберите правильный ответ",
        errorHint: "Подсказка об ошибке",
        addOption: "Добавить вариант",
        deletionConfirmation: "Вы уверены, что хотите удалить это упражнение?",
        total: "Всего",
        nExercises: "{count} упражнение | {count} упражнений",
        nVocabularies: "{count} словарь | {count} словарей",
        nPoints: "{count} балл | {count} баллов",
        addExercise: "Добавить упражнение",
        selectExerciseType: "Выберите тип упражнения",
        newVocabulary: "Новый словарь",
        linkExercisesFromQuiz: "Связать упражнения из викторины",
        linkVocabulary: "Связать словарь",
        searchLabel: "Поиск: название, тип",
        points: "Баллы",
        createdAt: "создано {createdAt}",
        goBack: "Вернуться назад",
        creating: "Создание",
        editing: "Редактирование",
        showCorrectnessOnError: "Показывать правильность после проверки",
        countPartialPts: "Учитывать частичные баллы",
        nOfxPts: "<b>{count}</b> из <b>{points}</b> баллов",
        upload: "Загрузить",
        record: "Запись",
        audioNotSelectedOrRecorded: "Аудио не выбрано или записано",
        preview: "Предпросмотр",
      },
      privacy: {
        privacy: "Конфиденциальность",
        public: "Публичный",
        publicDescription: "Все могут видеть этот материал",
        hidden: "Скрытый",
        hiddenDescription: "Только автор может видеть этот материал",
        scheduled: "Запланированный",
        scheduledDescription:
          "Этот материал может быть доступен с запланированной даты до 3 дней",
        forConnections: "Для связей",
        forConnectionsDescription:
          "Только связи автора могут видеть этот материал",
      },
      publication: {
        form: {
          title: {
            placeholder: "Заголовок",
          },
          level: {
            label: "Уровень",
          },
          description: {
            placeholder: "Описание",
          },
        },
        publicationIsEmpty: "Публикация пуста",
        selectFromMyOwnMaterials: "Выбрать из моих материалов",
        selectUsersToSend: "Выберите пользователя(ей) для отправки публикации",
        repostDescription: {
          repost:
            "Мгновенно разместить публикацию в ленте других пользователей",
          repostWithYourThoughts:
            "Создать новый пост на основе текущей публикации",
        },
        copyLinkToPublication: "Скопировать ссылку на публикацию",
        section: {
          generatedTitle: "Раздел #{value}",
          deletionConfirmation: "Вы уверены, что хотите удалить этот раздел?",
          addSection: "Добавить раздел",
          sectionIsEmpty: "Пока раздел пуст",
          addResource: "Добавить ресурс",
          selectResourceType: "Выберите тип ресурса",
          resource: {
            form: {
              content: {
                placeholder: "Напишите содержание ресурса...",
              },
            },
            deletionConfirmation: "Вы уверены, что хотите удалить этот ресурс?",
            copyLinkToResource: "Скопировать ссылку на ресурс",
            selectUsersToSend: "Выберите пользователя(ей) для отправки ресурса",
            groups: {
              interactivity: {
                title: "Интерактивность",
              },
              mediaAssets: {
                title: "Медиа ресурсы",
                items: {
                  media: "Изображение / Видео",
                  audio: "Аудио",
                  text: "Текст",
                },
              },
            },
            repostDescription: {
              repost:
                "Мгновенно разместить ресурс в ленте других пользователей",
              repostWithYourThoughts:
                "Создать новый пост на основе текущего ресурса",
            },
          },
        },
        searchForAnyMaterial: "Ищите любые материалы",
        own: "Собственные",
        common: "Общие",
        noPublicationsFound: "Публикаций не найдено",
        noSavedPublicationsFound: "Сохраненных убликаций не найдено",
        createPublication: "Создать публикацию",
        commonPublications: "Общие публикации",
        myPublications: "Мои публикации",
        savedPublications: "Сохраненные публикации",
        allMyPublications: "Все мои публикации",
        allSavedPublications: "Все сохраненные публикации",
      },
    },
    messages: {
      title: "Сообщения",
      chat: {
        title: "Чат",
        search: "Поиск...",
        writeMessage: "Написать сообщение...",

        typeToMessage: "Введите сообщение",
        endMessage: "Это конец сообщений",
        youDontHaveAnyChat: "Вы еще не общались",
        startChattingDescription:
          "Начните общение, выбрав одно из ваших соединений",
        startChatting: "Начать общение",
        send: "Отправить",
        connections: {
          title: "Соединения",
        },
      },
    },
    profileSettings: {
      title: "Настройки профиля",
      editingProfile: "Редактирование профиля",
      basicInfo: "Основная информация",
      aboutProfile: "О профиле",
      balanceDetalization: "Детализация баланса",
      backToProfileSettings: "Назад к настройкам профиля",
      interests: "Интересы и хобби",
      textbooks: "Учебники",
      prices: "Цены",
      additionalInfo: "Дополнительная информация",
      mainInfo: "Основная информация",
      firstName: "Имя",
      lastName: "Фамилия",
      email: "Эл. почта",
      phoneNumber: "Номер телефона",
      profilePhoto: "Изменить фото",
      buttonContinue: "Продолжить",
      shortAbout: "Кратко о себе",
      longAbout: "О себе",
      showOnRecommendationPage: "Показать на странице рекомендаций",
      shortAboutHint: "Кратко опишите себя",
      longAboutHint: "Опишите себя",
      buttonSave: "Сохранить",
      buttonPrevious: "Назад",
      pricesTab: {
        title: "Название",
        addMore: "Добавить еще",
      },
    },
    userProfile: {
      about: "О",
      wasOnline: "Был(а) в сети:",
      teaches: "Преподаёт:",
      speaks: "Говорит:",
      specialities: "Специализация:",
      textbooks: "Учебники:",
      interests: "Интересы:",
      learns: "Изучает:",
      prices: "Цены",
      priceTable: {
        title: "Название",
        price: "Цена (в час)",
      },
      mustRate: "Вы должны оценить по каждому критерию",
      leaveThoughts: "Оставьте свои мысли о преподавателе",
      reviewComponentTitle:
        "Пожалуйста, оцените работу преподавателя согласно вашим критериям",
      reviews: "Отзывы",
    },
    schedule: {
      title: "Расписание",
      plannedLesson: "Запланированный урок",
      start: "Начало",
      lessonWith: "Урок с {instructorFirstName} {instructorLastName}",
      deleteConfirmation:
        "Вы уверены, что хотите удалить план расписания урока?",
      today: "Сегодня",
      day: "День",
      week: "Неделя",
      month: "Месяц",
      "4days": "4 дня",
      createLessonSchedule: "Планирование нового урока",
      updateLessonSchedule: "Обновление существующего расписания",
      startNow: "Начать сейчас",
      schedule: "Расписание",
      calendarCard: {
        title: "Название",
        plannedDate: "Запланированная дата",
        lessons: "Уроки",
        students: "Студенты",
        notes: "Заметки",
      },
      history: "История",
      form: {
        headerTitle: "Планирование нового урока",
        title: {
          addTitle: "Добавить название",
          label: "Название",
        },
        startsFrom: {
          label: "Урок начинается с",
        },
        duration: {
          label: "Продолжительность",
          items: {
            "30min": "30 мин.",
            "45min": "45 мин.",
            "1hour": "1 час",
            "1halfHours": "1.5 часа",
            "2hours": "2 часа",
          },
        },
        lessons: {
          label: "Уроки",
          placeholder: "Начните вводить для поиска уроков",
          rules: {
            required: "Вы должны выбрать хотя бы один урок",
          },
        },
        quizzes: {
          label: "Викторина",
          placeholder: "Начните вводить для поиска викторин",
          rules: {
            required: "Вы должны выбрать хотя бы одну викторину",
          },
        },
        students: {
          label: "Студенты",
          placeholder: "Начните вводить для поиска из ваших контактов",
          rules: {
            required: "Вы должны выбрать хотя бы одного студента",
          },
        },
        price: {
          label: "Цена",
          rules: {
            required: "Вы должны указать положительное число",
          },
        },
        commonPrice: {
          label: "Общая цена",
        },
        notes: {
          addNotes: "Добавить заметки",
          label: "Заметки",
        },
      },
    },
    liveLesson: {
      tabs: {
        main: {
          title: "Основное",
        },
        attachments: {
          title: "Приложения",
          tabs: {
            audio: "Аудио",
            documents: "Документы",
            "board-documents": "Документы доски",
          },
        },
        exercises: {
          title: "Упражнения",
          tabs: {
            vocabulary: "Словарь",
            exercises: "Упражнения",
          },
        },
        whiteboard: {
          title: "Доска",
        },
        chat: {
          title: "Чат",
        },
        live: {
          title: "Эфир",
        },
        material: {
          title: "Материал",
        },
      },
      lesson: "Урок",
      currentLiveScheduledLessons: "Текущие прямые уроки",
      upcomingScheduledLessons: "Предстоящие запланированные уроки",
      noUpcomingSchedules: {
        title: "Нет предстоящих событий",
        description: "У вас нет запланированных предстоящих уроков",
      },
      attachments: {
        editAttachments: "Редактировать вложения",
        lessonAttachments: "Вложения урока",
        boardAttachments: "Вложения доски",
        noLessonAttachmentsAddedYet: "Пока нет добавленных вложений для урока",
        noLessonAudiosAddedYet: "Пока нет добавленных аудио для урока",
        noBoardAttachmentsAddedYet: "Пока нет добавленных вложений для доски",
      },
      live: {
        title: "Прямой эфир",
        join: "Присоединиться",
        videoIsNotAvailable: "Видео недоступно",
        you: "Вы",
        lessonIsOver: "Урок уже закончился",
        lessonNotStarted: "Урок еще не начался",
        readyToJoin: "Готовы подключиться?",
        youHaveNotJoinedYet:
          "Вы еще не присоединились к прямому эфиру. Хотите присоединиться?",
        lessonScheduledInfo:
          "Прямой урок запланирован на <b>{lessonStartsAt} - {lessonEndsAt}</b>",
        tooEarlyToJoin:
          "Ваш урок начнется в {lessonStartsTime} {lessonStartsDate}. Ваше местное время {localTime} {localDate}. <br />Однако, комната для встречи доступна вам за 20 минут до и после запланированного часа.",
        tooLateToJoin:
          "Ваш урок начался в {lessonStartsTime} и закончился в {lessonEndsTime} {lessonEndsDate}. Ваше местное время {localTime} {localDate}. <br />Однако, комната для встречи доступна вам за 20 минут до и после запланированного часа.",
      },
      board: {
        noBoardsCreatedYetInstructor:
          "Пока нет созданных досок, хотите создать?",
        noBoardsCreatedYetStudent:
          "Пока нет созданных досок, попросите вашего инструктора создать одну",
        add: {
          title: "Добавление новой доски",
          boardName: {
            label: "Название доски",
            placeholder: "Введите название доски",
          },
          cloneFrom: {
            title: "Клонировать из",
            lessonBoards: "Доски урока:",
            latestBoards: "Последние доски:",
            boardsWithCurrentStudents: "Доски с текущими студентами:",
          },
        },
        lock: "Блокировка",
        sync: "Синхронизация между пользователями",
        additionalOptions: "Дополнительные опции",
        borderStyleOpacityAndColor: "Стиль границы, прозрачность и цвет",
        colorAndOpacity: "Цвет и прозрачность",
        color: "Цвет",
        bringToFront: "Переместить на передний план",
        bringForward: "Переместить вперед",
        sendToBack: "Переместить на задний план",
        sendBackward: "Переместить назад",
        image: "Изображение",
        video: "Видео",
        audio: "Аудио",
        document: "Документ",
        fromYourDevice: "С вашего устройства",
        pasteDirectUrl: "Вставьте прямую ссылку",
        yourVideoUrl: "Ваша ссылка на видео",
        pasteViaYouTubeUrl: "Вставьте через ссылку YouTube",
        youTubeVideoUrl: "Ссылка на видео YouTube",
      },
      audio: {
        addAudio: "Добавить аудио",
        editAudio: "Редактировать аудио",
      },
      attachment: {
        add: "Добавить вложениe",
        edit: "Редактировать вложение",
      },
      exercise: {
        addExercises: "Добавить упражнения",
        editExercises: "Редактировать упражнения",
        noLessonExercisesAttachedYet:
          "Пока нет добавленных упражнений для урока",
      },
      vocabulary: {
        addVocabulary: "Добавить словарь",
        editVocabulary: "Редактировать словарь",
        noLessonVocabularyAttachedYet:
          "Пока нет добавленного словаря для урока",
      },
      chat: {
        typeSomething: "Напишите что-нибудь...",
      },
      noAnyLessonAddedYet: "Пока нет добавленных уроков",
      addLesson: "Добавить урок",
      authRequired: "Требуется авторизация",
      authRequiredDescription:
        "Пожалуйста, войдите или создайте аккаунт, чтобы присоединиться к прямому уроку",
    },
    accessDenied: {
      title: "Доступ запрещен, недостаточно привилегий",
    },
    pageNotFound: {
      title: "Страница не найдена",
    },
    landing: {
      // Header
      greeting: "Привет",
      howItWorks: "Как это работает",
      findTeacher: "Преподаватели",
      advantages: "Преимущества",
      prices: "Тарифы",

      // Hero
      socialPlatform:
        "Онлайн-платформа для изучения и преподавания английского языка",
      hereSuccess:
        "Здесь ученики говорят «Спасибо» по-настоящему профессиональным учителям и рекомендуют их другим людям.",
      register: "Регистрация и вход",
      findATeacher: "Найти преподавателя",
      magicStarts:
        "«Я уважаю таких людей с высокой внутренней культурой и доверяю их мнению. Доверяю больше, чем самой красивой рекламе».",
      heroAddress: "Акылай, мисс Кыргызстан 2023",

      // GALLERY
      dontRisk: "Не верьте рекламе. Доверяйте отзывам и «сарафанному радио».",
      weOffer:
        "Мы предлагаем простые и доступные инструменты для оценки профессионализма учителей английского языка.",
      supportedByLocal: "Нас поддерживают известные блогеры",
      criteria: "6 критериев",
      assessTeachers: "Оценки качества обучения преподавателей",
      freeForStudents: "Бесплатно для учеников",
      realTestimonials: "Реальные отзывы учеников",

      //   whyChoose
      weHelp: "Мы помогаем",
      students: "Ученикам",
      toFindIdealTeacher:
        "Найти идеального учителя на основе отзывов и независимой оценки профессиональных качеств. Получить образование, которое полностью удовлетворяет вашим целям.",
      teachers: "Преподавателям",
      toDevelop:
        "Создать бренд преподавателя-профессионала и продвигать себя на основе отзывов, независимой оценки профессиональных качеств, репутации и честной конкуренции.",
      //   howItIsWork
      seeHowItWork: "Смотрите, как это работает",
      choosingATeacher: "Как выбрать преподавателя",
      lessonRoutine: "Как проходит оценка учителей",
      independentAssessment: "Независимая оценка на работе",
      //   Testimonials
      communityIndependent: "Подробнее о системе отзывов и оценок",
      howToChoose: "Выбор преподавателя",
      findYourIdealTeacher:
        "Ученик выбирает преподавателя на основе четких критериев оценки профессионализма (пунктуальность, знание предмета, подача материала урока, требовательность, мягкость, результативность и т.д).",
      findYourIdealTeacher2:
        "Можно также выбрать преподавателя по специальности (английский для бизнеса, IT и т.д.) или по цене. Также можно написать преподавателю напрямую.",

      ourQualityControl: "Честный подход",
      theLessonsAreConducted:
        "Уроки проводятся внутри нашей платформы, чтобы мы могли получить реальные отзывы от настоящих студентов.",
      inAddition:
        "В дополнение, платформа очень удобна. Все необходимое для учеников и преподавателей уже есть на платформе: учебники, планы обучения, интерактивные упражнения, аудирование, онлайн-созвон, доска для совместной работы и многое другое.",
      testimonialsAfterLesson: "Отзыв после урока",
      byTheEndOf:
        "В конце занятия появляется форма для заполнения отзыва. Ученик по желанию может поставить оценку учителю и написать отзыв. Чем больше уроков было у ученика, тем, больше влияет его оценка и отзыв на рейтинг преподавателя.",

      //   ProfileSection
      exampleProfile: "Пример профиля преподавателя",
      aboutMe: "Обо мне",
      myStudentsReach:
        "Мои ученики добиваются своих целей. Я заработал репутацию хорошего предметника, результативного и требовательного репетитора и об этом говорят оценки моего профессионализма и отзывы учеников.",
      education: "Образование",
      americanUniversity: "American University in Central Asia",
      certificates: "Сертификаты",
      testimonials: "Отзывы",
      readMore: "Смотреть",
      provenCapability: "подача материала",
      strictness: "требовательность",
      punctuality: "пунктуальность",
      skillsDeveloped: "результативность",
      overallLessons: "количество уроков",
      lessonPrice: "цена за урок",
      yourPhone: "Ваш телефон",
      yourContact: "  Ваши контакты переданы учителю.  ",
      yourContact2: "Не хотите ждать? Позвоните сами.",

      bySending:
        "Отправляя ваши данные, вы соглашаетесь с положением Политики конфиденциальности",
      exchangeContacts: "Обменяться контактами",
      call: "Позвонить",
      completedLesson: "пройдено 10 уроков",
      studentRating: ` Айгуль была моим репетитором в течение полутора лет. У нас проводились как очные, так и онлайн занятия, и оба варианта меня полностью удовлетворили. Атмосфера во время занятой была дружелюбной, чувствовался индивидуальный подход. `,

      //   chooseTeacher
      howToFind: "Как выбрать учителя на нашем сайте?",
      clearAssessment:
        "Чёткие критерии оценки профессионализма учителей на базе реальных отзывов реальных людей.",
      whatIsPunctuality: "Как найти самых пунктуальных преподавателей?",
      howToFindACompetentTeacher: "Как найти компетентного преподавателя",
      howToFindAResultOrientedTeacher:
        "Как найти преподавателя, который дает результат",
      howToFindThePerfectTeacher: "Как найти идеального преподавателя",
      demanding: "Требовательный учитель. Преимущества? ",
      howLesson: "Как проходит урок?",
      aboutUs: "О проекте",

      //     teachers In Platform
      ourTeachers: "Преподаватели на платформе",
      aigul: "Айгуль",
      experience:
        "Дипломированный специалист по английской филологии. Опыт преподавания - 5 лет.",
      readMoreBtn: "Подробнее",
      chooseATeacher: "Выбрать преподавателя",
      becomeATeacher: "Стать преподавателем",

      //     level
      whatIsYourLevel: "Узнайте свой уровень английского",
      doTheTest:
        "Заполните тест. Мы отправим вам видеоразбор ваших ошибок, индивидуальный план обучения и подберем идеального преподавателя.",
      tryItNow: "Пройти тест",
      //   help learners
      weHelpLearners: `Мы помогаем преподавателям и ученикам найти друг друга и сделать обучение максимально эффективным`,

      //   Guaranteed
      guaranteedBenefits: "Гарантированная выгода ученикам и преподавателям",
      toTheStudents: "Ученикам",
      realRating:
        "Реальные отзывы реальных людей вместо очередной рекламы и пустых обещаний",
      riskFree:
        "Правильно выбрать учителя ориентируясь на четкие критерии оценки профессионализма",
      studyMotivated: "Заниматься с мотивированным учителем",
      workWithout:
        "Оплачивать учителю согласно компетенциям, без обычных затрат на зарплату администрации курсов",
      noWaitList:
        "Звонить учителю напрямую, быстро и эффективно решать организационные моменты без ожидания ответа администрации",
      easyLearn:
        "Выучить английский легко по методике, с помощью которой набирают максимальные баллы по международным экзаменам (TOЕFL, IELTS, SAT)",

      //   teacher
      toTheTeacher: "Преподавателям",
      anOpportunity:
        "Возможность создать бренд преподавателя-профессионала, подкрепленный независимой оценкой и отзывами учеников",
      avoidEmotional:
        "Избежать выгорания. Вы будете получать регулярные отзывы от своих учеников, включая слова благодарности и предложения по дальнейшему развитию",
      theOpportunityToTeach:
        "Возможность преподавать, самостоятельно определяя цену, забирая весь чек себе",
      increaseCost:
        "Увеличить стоимость часа занятий, на деле доказав свои компетенции",
      increaseYourIncome:
        "Увеличить доход, перейдя с индивидуальных на групповые занятия",
      workWithoutInter:
        "Работать без посредников, организовать работу так, как удобно ученику и Вам",

      // convenient-platform
      convenientTitle:
        "Одна удобная платформа вместо десяти непонятных приложений",
      allYouNeed: "Всё нужное в одном месте",
      doUVideoCall:
        "Общаетесь в Зуме, читаете книги в другом окне, отправляете файлы через Вотсап? В нашей платформе всё это есть в одном окне.",
      trackProgress: "Отслеживайте прогресс",
      inStudents:
        "В личном кабинете можно проверять домашние задания и проводить работу над ошибками.",
      stableVideoCall: "Стабильная связь",
      hdQuality:
        "Качественная связь с минимальной задержкой во времени даже при плохом интернете и защитой от выбивания",
      affordablePrice: "Доступные цены",
      weTake:
        "Мы не берем комиссию за каждый проведенный урок. Поэтому учителя могут назначать удобную для них цену.",

      // view possibilities
      seeWhatInside: "Посмотрите на все возможности платформы",
      tryItYourself: "Войти на платформу",
      audio: " Аудирование",
      test: "Тесты",
      dictionary: "Словарь",
      board: " Доска для работы",

      //   Plans
      planPrices: "Тарифы",
      forThePlatform: "₽ за пользование платформой",
      tryIt: "Попробовать",
      useItForFree: "Пользуйтесь бесплатно",
      monthly: "₽ в месяц",
      currency: "1000",
      firstMonth: "Первый месяц бесплатно",

      //    creator
      aboutFounder: "О создателе",
      goToProfile: "Перейти в профиль",
      ceoName: "Руслан Леонтьев",
      ceoExperience: "Преподаватель английского языка со стажем 7 лет.",
      ceoUniversity: "Выпускник American University in Central Asia",

      ceo1Text: `Привет! Меня зовут Руслан Леонтьев. Я родом из маленького городка, и в этом мне в чем-то повезло. В отличии от больших городов, где правят неоновые огни рекламных плакатов, в моём городке всего этого нет. У нас даже нет курсов английского, да и с интернетом не очень. Поэтому не о какой рекламе образовательных услуг мы не слышали. Хочешь заниматься английским? Иди к Галине Джораевне – так говорят у нас. Здесь люди живут тесной общиной, обмениваются новостями, рекомендуют друг другу специалистов, а сарафанное радио и собственная репутация – единственные маркетинговые технологии.`,
      ceo2Text: `В 2007 году, вернувшись с армии в родной городок, я решил заняться образованием. По рекомендации соседей я оказался у Галины Джораевны, где неожиданно для себя открыл целый мир, в котором молодые люди, занимавшиеся у моего учителя, начинали свободно говорить на английском. Однако на этом мы не останавливались...`,
      ceo3Text: `Все мечтали о сверх результате – набрать максимальные балы по международным экзаменам (TOЕFL, IELTS, SAT), чтобы поступить в престижный зарубежный университет на стипендию, и практически всем это удалось. Алишер поступил в University of Washington, Спартак в American University in Bulgaria. Через четыре года, среди выпускников American University in Central Asia, кроме меня, было ещё пять учеников Галины Джораевны.`,
      ceo4Text: `В 2007 году, когда я первый раз постучался в дверь своего учителя, «образование за рубежом» ещё не было популярным рекламным лозунгом, и мои друзья из столицы крутили указательным пальцем у виска, говоря, «Да кто тебя вообще там ждёт?», мы, ученики Галины Джораевны получали большие стипендии и приглашения из разных университетов мира.`,
      ceo5Text: `Люди в больших городах живут по иным законам. Все спешат и всё реже находят время общаться, обменяться ценной информацией, порекомендовать друг другу специалистов. Поэтому сарафанное радио в городе не работает, а реклама заполняет пробел в общение. Оглядываясь назад я понимаю, что я человек, которому ужасно повезло родится в маленьком городке, иначе, Галина Джораевна и я не нашли друг друга. Ведь у моего учителя нет времени выкладывать рилсы в Инстаграм, а каждую свободную минуту она посвящает любимому делу – преподаванию. Она не любит заниматься саморекламой, бросать пыль в глаза. И вот такие вот преподаватели от Бога, (их кстати очень много) к сожалению, не могут ужиться в городе. Их просто не будет видно и слышно среди толпы кричащих о себе и своих услугах курсов английского языка.`,
      ceo6Text: `Я призываю людей к простоте выбора. Не верьте рекламе. Доверяйте отзывам и сарафанному радио. Community – это сообщество отзывов. Мы предлагаем независимую оценку Ваших учителей английского языка на основе их рейтингов и честных отзывов.`,

      hidden: "Скрыть",
      seeMore: "Показать ещё",

      //    form component
      startTeaching: "Начните изучать или преподавать английский уже сегодня",
      byRegister: `Регистрируясь на сайте Lingua.community, вы становитесь частью новой культуры. Мы — сообщество успешных и самодостаточных людей, которые говорят спасибо по-настоящему профессиональным учителям и рекомендуют их другим людям. Если вам нужна помощь или консультация, мы будем рады помочь вам.`,
      connectAndJoin: "Подключиться",
      talkToUs: "Задать вопрос в Telegram",

      // footer
      companyName: "OcOO Леонтьев и Партнёры",
      terms: "Условия использования",
      personalInfo: "Политика конфиденциальности",
      europe: "Финансируется фондом Accelerate Prosperity",
      socialNetworks: "Мы в соцсетях",
      techSupport: "Техническая поддержка",

      //   rating
      firstRatingName: "Акылай Калбердиева",
      firstRatingDescription:
        "За три месяца занятий с Вами я повысила свой уровень от pre-intermediate до advanced.",
      firstRatingLessons: "Пройдено 42 урока. ",

      secondRatingName: "Дунганова Джамиля",
      secondRatingDescription: `Мне очень понравилась методика обучения Руслана, она включала аудирование, свободное письмо, разбор грамматических тем, различные упражнения на закрепление материала. После 1 года занятий, я перешла на более высокий уровень владения английским языком, я стала лучше понимать английскую речь, составлять небольшие тексты, улучшила разговорный язык и перестала переживать по поводу правильности своего произношения.`,
      secondRatingLessons: "Пройдено 158 уроков ",

      thirdRatingName: "Салижан Жумалиев",
      thirdRatingDescription: `Мне 17 лет. Недавно я сдал IELTS на 7.5. За это я благодарен Леонтьеву Руслану. Всем рекомендую своего учителя. `,
      thirdRatingLessons: "Пройдено 216 уроков",

      fourRatingName: "Адель Асаналиева",
      fourRatingDescription: `Я поступила в университет. Англия Раскин в Кэбридже. По направлению биомедицина. Хотела выразить благодарность своему учителю Леонтьеву Руслану, который помогал подготовиться к международным экзаменам и получить высокие баллы, поступить в престижный университет, а также за помощь в академическом и личностном росте.  `,
      fourRatingLessons: "Пройдено 314 уроков",
    },
    termsOfService: {
      content:
        '<div class="text-center text-h5">Условия использования</div><div class="text-right">Дата вступления в силу: 15 июля 2024 года</div><div class="mt-2"><p>Добро пожаловать в <a href="https://lingua.community">lingua.community</a> (далее "Приложение"), оператором которого является ОсОО "Леонтьев и Партнеры" ("Компания", "мы", "нас" или "наш"), компания, зарегистрированная в Бишкеке, Кыргызстан. "мы" или "наш"), компанией, зарегистрированной в Бишкеке, Кыргызстан. Заходя на доступ к Приложению или его использование, вы соглашаетесь соблюдать и быть связанными следующие положения и условия ("Условия"). Пожалуйста, внимательно ознакомьтесь с настоящими Условиями перед использованием Приложения. Если вы не согласны с настоящими Условиями, вы не должны использовать Приложение. Переведено с помощью DeepL.com (бесплатная версия)</div><ol class="mt-3"><li><div>Учетные записи пользователей</div><ol><li><div>Регистрация</div><p>Пользователи могут создавать учетные записи в Приложении в качестве учителя или ученика (каждая из них - "Учетная запись"). Создавая учетную запись, вы заявляете и гарантируете, что предоставленная вами информация является точной, актуальной и полной. Вы несете ответственность за сохранение конфиденциальности и безопасности учетных данных вашей Учетной записи.<li><div>Типы аккаунтов</div><ul><li>Учителя: Пользователи, зарегистрированные как преподаватели, могут планировать видеовстречи, загружать образовательный контент, создавать викторины и тесты с мгновенной обратной связью и делиться ими с учениками.<li>Студенты: Пользователи, зарегистрированные как студенты, могут участвовать в онлайн-встречах, запланированных преподавателями, и получать доступ к образовательному контенту, созданному преподавателями.</ul><li><div>Возрастные ограничения и юридическая ответственность</div><ul><li>Услуги доступны и могут использоваться только лицами, достигшими 18 лет и способными заключать юридически обязывающие договоры в соответствии с действующим законодательством.<li>Лица в возрасте до 18 лет, но не моложе 13 лет, могут пользоваться нашими Услугами только вместе с родителем или законным опекуном и под его присмотром. Родитель или законный опекун всегда несет ответственность за все действия, связанные с использованием Услуг вышеупомянутыми лицами.</ul></ol><li class="mt-2"><div>Услуги онлайн-образования</div><ol><li><div>Особенности</div><ul><li>Приложение предоставляет инструменты для индивидуальных и групповых занятий в режиме реального времени, такие как видеовстречи, интерактивная онлайн-доска, викторины и тесты с мгновенной обратной связью.</ul><li><div>Оценка преподавателя</div><ul><li>Приложение предлагает инструменты для оценки профессиональных качеств преподавателей по трем критериям: пунктуальность, доказанные способности и развитие навыков.<li>Публичная оценка: Преподаватель соглашается публично выставлять оценки, полученные им через оценки студентов, и отзывы, которые студенты оставляют о его преподавательской деятельности, независимо от того, являются ли эти оценки и отзывы положительными или отрицательными. Компания не исправляет отзывы и оценки, за исключением случаев, когда Ученик намеренно оскорбляет, обзывается.</ul><li><div>Услуги платформы</div><ul><li>Компания не предоставляет образовательных услуг самостоятельно. Наоборот, <b>**lingua.community**</b> предоставляет инструменты для взаимодействия преподавателей и студентов.</ul></ol><li class="mt-2"><div>Финансовая и методологическая независимость</div><ol><li><div>Политика оплаты</div><ul><li>Компания не является посредником в финансовых, методических и дисциплинарных вопросах между Преподавателями и Учениками. Стоимость и порядок оплаты онлайн-урока, а также порядок отмены урока определяются исключительно Преподавателем и Учеником.</ul><li><div>Разногласия</div><ul><li>В случае возникновения разногласий между студентом и преподавателем по поводу недоплаты, несвоевременной оплаты, политики отмены уроков или любых других финансовых вопросов, Компания не несет ответственности.</ul><li><div>Обязанности по уплате налогов и лицензированию</div><ul><li>Преподаватели несут ответственность за уплату всех необходимых налогов и получение необходимых лицензий в соответствии с налоговым законодательством страны, в которой они работают. Например, преподаватели из Кыргызстана должны приобрести патент репетитора и оплатить сертификат социального фонда.</ul></ol><li class="mt-2"><div>Отзывы студентов</div><ol><li><div>Свидетельские права</div><ul><li>Студенты имеют право писать отзывы об услугах своего преподавателя и оценивать его профессиональные качества. Компания не исправляет и не изменяет отзывы, за исключением случаев, когда ученики обзывают, унижают, позорят учителя или дискриминируют группу людей по этническому, национальному, религиозному, гендерному признаку. Любой пользователь может сообщить о таком нарушении через мессенджеры Telegram по адресу <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> или <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a> или позвонив по прямому номеру <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a></ul><li><div>Формат свидетельства</div><ul><li>Компания укажет количество уроков, проведенных учеником до написания отзыва, и добавит эту информацию в текст отзыва.<br>Например, если ученик по имени Руслан взял 10 онлайн-уроков у конкретного преподавателя по имени Гэрри Гудсон, и Руслан написал: "Мистер Гэрри Гудсон - очень компетентный преподаватель. Он отвечает на все мои вопросы и приводит дополнительные примеры, исключения из правил, которые не упоминаются в учебнике", то отзыв появится на сайте в следующем виде: "Руслан взял 10 уроков у Гарри Гудсона". Руслан написал: "Мистер Гарри Гудсон - очень компетентный преподаватель. Он отвечает на все мои вопросы и приводит дополнительные примеры, а также исключения из правил, которые не упоминаются в учебнике".</ul></ol><li class="mt-2"><div>Поведение пользователя</div><ol><li><div>Загрузка содержимого</div><ul><li>Пользователи несут ответственность за любой контент, который они загружают, передают или создают с помощью Приложения. Компания оставляет за собой право удалять любой контент, нарушающий настоящие Условия или действующее законодательство, особенно если контент нарушает авторские права, содержит любые виды дискриминации, включая, но не ограничиваясь этнической, гендерной или национальной.</ul><li><div>Запрещенная деятельность</div><ul><li>Нарушение авторских прав: Учителям запрещено использовать материалы и контент, на которые распространяется запрет на авторское право. Если учитель использует материалы и контент, нарушающие авторские права, его аккаунт будет закрыт, а контент, нарушающий авторские права, будет удален без возможности восстановления.<li>Пользователи могут загружать контент из приложения, но только для личного использования. Распространять загруженный из приложения контент третьим лицам запрещено.<li>Пользователи не должны использовать Приложение для каких-либо незаконных целей или заниматься любой деятельностью, которая нарушает или мешает работе Приложения.</ul><li><div>Взаимодействие с пользователем и личная безопасность</div><p>Компания не поддерживает и не делает никаких заявлений или гарантий относительно точности, полноты и надежности любой информации, предоставленной учителем или учеником. lingua.community не может подтвердить, что каждый Пользователь является тем, за кого себя выдает. При общении с другими Пользователями следует проявлять осторожность и здравый смысл для защиты своей личной безопасности и имущества, как и при общении с незнакомыми людьми. Ни Компания, ни lingua.community не несут ответственности за поведение, как онлайн, так и офлайн, любого Пользователя Услуг.<li><div>Предотвращение мошенничества и кражи личных данных</div><p>Пользователи должны отвечать только на сообщения, отправленные через наши официальные каналы связи: Telegram <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a> или <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, и WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a>.<br>Любые попытки связаться с нашими пользователями по другим каналам, утверждая, что они представляют компанию, считаются злонамеренной попыткой кражи личных данных.<p>Пользователи никогда не должны сообщать номера своих кредитных карт, идентификационные номера паспортов или любую другую конфиденциальную информацию на сайтах, не имеющих в качестве корневого домена lingua.community. Компания не продает подписки с использованием других сайтов.</ol><li class="mt-2"><div>Сборы и платежи</div><ol><li><div>Абонентская плата для учителей</div><ul><li>За пользование приложением с учителей ежемесячно взимается плата в размере 1000 сомов (кыргызских сомов). Если в платежной операции используется валюта, отличная от кыргызских сомов (KGS), сумма платежа будет рассчитана по курсу национального банка Кыргызстана на момент совершения операции.</ul></ol><li class="mt-2"><div>Интеллектуальная собственность</div><ol><li><div>Владение</div><ul><li>Приложение и все его содержимое, функции и функциональные возможности принадлежат Компании или ее лицензиарам и защищены международными законами об авторском праве, товарных знаках, патентах, коммерческой тайне и другими законами об интеллектуальной собственности или правах собственности.</ul><li><div>Лицензия</div><ul><li>Пользователям предоставляется ограниченная, неисключительная, не подлежащая передаче и отзывная лицензия на использование Приложения в личных или образовательных целях в соответствии с настоящими Условиями.</ul></ol><li class="mt-2"><div>Отказ от гарантий</div><p>Приложение предоставляется на условиях «как есть» и «как доступно». Компания не дает никаких гарантий, явных или подразумеваемых, в отношении работы Приложения или информации, контента или материалов, включенных в него.<li class="mt-2"><div>Ограничение ответственности</div><p>Ни при каких обстоятельствах Компания не несет ответственности за любые косвенные, случайные, особые, косвенные или штрафные убытки, возникшие в результате или связанные с использованием вами Приложения.<li class="mt-2"><div>Изменения в Условиях</div><p>Компания оставляет за собой право изменять настоящие Условия в любое время. Любые изменения вступят в силу немедленно после публикации пересмотренных Условий в Приложении. Ваше дальнейшее использование Приложения после публикации пересмотренных Условий означает ваше согласие с изменениями.<li class="mt-2"><div>Применимое право</div><p>Настоящие Условия регулируются и толкуются в соответствии с законодательством Кыргызской Республики без учета принципов коллизионного права.<li class="mt-2"><div>Контактная информация</div><p>По любым вопросам или сомнениям относительно настоящих Условий свяжитесь с нами по адресу:<br><br>ООО «Леонтьев и партнеры»<br>[Юг-2, д.14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><li class="mt-2"><div>Политика использования файлов cookie для зарегистрированных и незарегистрированных пользователей</div><p>В настоящей Политике использования файлов cookie объясняется, как сайт lingua.community («мы», «нас» или «наш»), которым управляет ООО «Леонтьев и партнеры», использует файлы cookie и аналогичные технологии, чтобы узнавать вас, когда вы посещаете наш веб-сайт по адресу https://lingua.community. В нем объясняется, что это за технологии, почему мы их используем, а также ваши права контролировать их использование.<ol><li><div>Что такое файлы cookie?</div><p>Файлы cookie — это небольшие файлы данных, которые сохраняются на вашем компьютере или мобильном устройстве при посещении веб-сайта. Файлы cookie широко используются владельцами веб-сайтов для обеспечения работы или повышения эффективности их веб-сайтов, а также для предоставления отчетной информации.<li><div>Почему мы используем файлы cookie?</div><p>Мы используем файлы cookie по нескольким причинам. Некоторые файлы cookie необходимы по техническим причинам для работы нашего веб-сайта, и мы называем их «необходимыми» или «строго необходимыми» файлами cookie. Другие файлы cookie позволяют нам отслеживать и ориентироваться на интересы наших пользователей, чтобы улучшить качество обслуживания на нашем веб-сайте. Например, мы используем файлы cookie, чтобы узнавать вас, когда вы возвращаетесь на наш веб-сайт, чтобы предоставлять соответствующий контент и обнаруживать потенциальные угрозы безопасности.<li><div>Типы файлов cookie, которые мы используем:</div><ol><li>Основные файлы cookie. Эти файлы cookie строго необходимы для предоставления вам услуг, доступных через наш веб-сайт, и для использования некоторых его функций, таких как доступ к защищенным областям.<li>Файлы cookie производительности и функциональности. Эти файлы cookie используются для повышения производительности и функциональности нашего веб-сайта, но не являются обязательными для его использования. Однако без этих файлов cookie некоторые функции (например, видео) могут стать недоступными.<li>Файлы cookie аналитики и настройки. Эти файлы cookie собирают информацию, которая используется либо в совокупной форме, чтобы помочь нам понять, как используется наш веб-сайт или насколько эффективны наши маркетинговые кампании, либо чтобы помочь нам настроить наш веб-сайт для вас.<li>Файлы cookie безопасности. Эти файлы cookie помогают выявлять и предотвращать угрозы безопасности. Мы используем эти файлы cookie для аутентификации пользователей и защиты пользовательских данных от посторонних лиц.</ol><li><div>Ваш выбор в отношении файлов cookie</div><p>Вы имеете право решать, принимать или отклонять файлы cookie. Вы можете воспользоваться своими предпочтениями в отношении файлов cookie, настроив или изменив элементы управления веб-браузером, чтобы принимать или отклонять файлы cookie. Если вы решите отказаться от файлов cookie, вы все равно сможете использовать наш веб-сайт, хотя ваш доступ к некоторым функциям и областям нашего веб-сайта может быть ограничен.<li><div>Как удалить файлы cookie</div><p>Если вы хотите удалить файлы cookie или указать своему веб-браузеру удалить или отказаться от файлов cookie, посетите страницы помощи вашего веб-браузера:<ol><li>Для Chrome: [Google Chrome] ( <a href="https://support.google.com/chrome/answer/95647" target="_blank">https://support.google.com/chrome/answer/95647 </a>)<li>Для Internet Explorer: [Microsoft Internet Explorer] ( <a href="https://support.microsoft.com/kb/278835" target="_blank">https://support.microsoft.com/kb/278835 </a>)<li>Для Firefox: [Mozilla Firefox] ( <a href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored" target="_blank">https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored </a>)<li>Для Safari: [Apple Safari] ( <a href="https://support.apple.com/guide/safari/sfri11471/mac" target="_blank">https://support.apple.com/guide/safari/sfri11471/mac </a>)</ol><p>Обратите внимание: если вы удалите файлы cookie или откажетесь принять их, вы не сможете использовать все предлагаемые нами функции, вы не сможете сохранить свои предпочтения, а некоторые наши страницы могут отображаться некорректно.<li><div>Изменения в настоящей Политике использования файлов cookie</div><p>Мы можем время от времени обновлять настоящую Политику в отношении файлов cookie, чтобы отражать, например, изменения в используемых нами файлах cookie или по другим эксплуатационным, юридическим или нормативным причинам. Пожалуйста, регулярно просматривайте настоящую Политику в отношении файлов cookie, чтобы быть в курсе использования нами файлов cookie и связанных с ними технологий.</ol></ol><p class="mt-2">ООО «Леонтьев и партнеры»<br>[Юг-2, д.14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Тел.: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>Используя наш веб-сайт, вы подтверждаете, что прочитали, поняли и соглашаетесь соблюдать настоящую Политику использования файлов cookie.',
    },
    privacyPolicy: {
      content:
        '<div class="mx-2 my-4"><div class="text-center text-h5">Политика конфиденциальности</div><div class="text-right">Дата вступления в силу: 15 июля 2024 года</div><div class="mt-2"><p>Добро пожаловать в сообщество Lingua ("мы", "наш", "нас"). Настоящая политика конфиденциальности объясняет, как Leontev and Partners LLC, расположенная в Кыргызстане, г. Бишкек, Юг-2, д. 14 ("Компания"), собирает, использует, раскрывает и защищает ваши данные при посещении нашего веб-сайта <a href="https://lingua.community">lingua.community</a> и использовании наших услуг. Используя наш веб-сайт, вы соглашаетесь с условиями настоящей политики конфиденциальности. Текущая Политика конфиденциальности приложения включена в Соглашение об использовании приложения.</div><ol class="mt-3"><li><div>Собираемая информация</div><ul><li><div>Персональные данные</div><p>При регистрации учителем или учеником через вашу учетную запись Google мы собираем ваше полное имя, фотографию профиля и адрес электронной почты. Эти данные становятся доступными для публичного доступа на нашей платформе.<li><div>Данные, специфичные для учителей</div><p>Учителя предоставляют образовательные услуги и оцениваются студентами по критериям, таким как пунктуальность, компетентность, развитие навыков и другим параметрам. Эти оценки являются общедоступными.<li><div>Отзывы</div><p>Мы собираем и отображаем отзывы об образовательных услугах, предоставляемых на платформе. Учитель соглашается принять отзывы от студентов без изменения их содержания. Отзывы содержат полные имена учителя и студента, а также количество проведенных уроков до публикации отзыва. Количество проведенных уроков на веб-сайте автоматически отслеживается и хранится в вашем личном профиле. Количество проведенных уроков с конкретным студентом становится общедоступным только после получения отзыва от студента.<li><div>Данные использования</div><p>Мы собираем информацию о ваших взаимодействиях с нашим веб-сайтом, таких как посещенные страницы, время и дата визитов, количество проведенных уроков, ваш IP-адрес и местоположение, а также другие диагностические данные.<li><div>Файлы cookie и аналогичные технологии</div><p>Мы используем файлы cookie для определения вашего IP-адреса и местоположения, а также для улучшения общего пользовательского опыта. Эти технологии помогают нам понять, как вы взаимодействуете с нашими услугами и предоставить лучший опыт.</ul><li><div>Как мы используем ваши данные</div><p>Мы используем собранную информацию для:<ul><li>Предоставления и поддержки наших услуг<li>Отображения профилей учителей и их оценок для незарегистрированных пользователей<li>Отображения отзывов с именами и количеством уроков<li>Уведомления вас об изменениях в наших услугах<li>Предоставления поддержки клиентам<li>Анализа использования нашего веб-сайта для улучшения наших услуг<li>Выявления, предотвращения и устранения технических проблем<li>Соблюдения юридических обязательств и обеспечения соблюдения наших условий</ul><li><div>Передача ваших данных</div><p>Мы не продаем и не передаем вашу личную информацию третьим лицам, за исключением случаев:<ul><li>С вашего согласия<li>Отображения профилей учителей и их оценок для незарегистрированных пользователей<li>Для выполнения юридических обязательств<li>Для защиты и защиты наших прав и собственности<li>С поставщиками услуг для выполнения работ от нашего имени<li>В связи с любым объединением, продажей активов компании, финансированием или приобретением всего или части нашего бизнеса другой компанией</ul><li><div>Публично доступная информация</div><ul><li>Профили учителей, включая полные имена, фотографии профилей, оценки и отзывы, доступны для общего доступа любому пользователю.<li>Отзывы включают полные имена как учителя, получающего отзыв, так и студента, написавшего отзыв, а также количество проведенных уроков.</ul><li><div>Безопасность вашей информации</div><p>Мы используем административные, технические и физические меры безопасности для защиты вашей личной информации. Однако ни один метод передачи данных через интернет или электронное хранение не является 100% безопасным.<li><div>Ваши права на защиту данных</div><p>В зависимости от вашего местоположения у вас могут быть следующие права в отношении ваших персональных данных:<ul><li>Право на доступ<li>Право на исправление<li>Право на удаление<li>Право на ограничение обработки<li>Право на портабельность данных<li>Право на возражение</ul><li><div>Политика файлов cookie и аналогичных технологий</div><p>Мы используем файлы cookie и аналогичные технологии для:<ul><li>Определения вашего IP-адреса и местоположения<li>Улучшения взаимодействия и опыта пользователей на нашем веб-сайте</ul><p>Вы можете управлять предпочтениями файлов cookie через настройки вашего браузера. Для получения дополнительной информации о том, как управлять файлами cookie и аналогичными технологиями, пожалуйста, ознакомьтесь с нашей <a href="/terms-and-conditions-agreement">[Политикой использования файлов cookie]</a><li><div>Услуги третьих сторон</div><p>Наши услуги могут содержать ссылки на веб-сайты или услуги третьих сторон, включая Google. Мы не контролируем эти сайты третьих сторон и не несем ответственности за их политику конфиденциальности. Мы рекомендуем вам ознакомиться с политикой конфиденциальности этих третьих сторон.<li><div>Конфиденциальность детей</div><p>Наши услуги не предназначены для лиц младше 13 лет. Мы не собираем намеренно личную информацию от детей младше 13 лет. Если мы узнаем, что мы собрали личную информацию от ребенка младше 13 лет, мы примем меры по удалению такой информации.<li><div>Изменения в настоящей Политике конфиденциальности</div><p>Мы можем время от времени обновлять нашу Политику конфиденциальности. Мы уведомим вас о любых изменениях, разместив новую Политику конфиденциальности на этой странице и обновив "Дата вступления в силу" вверху.<li><div>Свяжитесь с нами</div><p>Если у вас есть вопросы по поводу настоящей Политики конфиденциальности, пожалуйста, свяжитесь с нами по адресу <a href="mailto:skypestudy.org@gmail.com">skypestudy.org@gmail.com</a> и/или WhatsApp <a href="https://wa.me/996554877853">+996 (554) 877-853</a></ol><p class="mt-2">Leontev and Partners LLC<br>[Юг-2, д. 14]<br>Бишкек, Кыргызстан<br>Telegram: <a href="https://t.me/leontevruslan" target="_blank">@leontevruslan</a>, <a href="https://t.me/linguacommunity" target="_blank">@linguacommunity</a><br>Tel: <a href="tel:+996 (554) 877-853">+996 (554) 877-853</a><p>Используя наш веб-сайт, вы подтверждаете, что ознакомились, поняли и согласны с настоящей Политикой конфиденциальности.</div>',
    },
  },
  messages: {
    lessonDeleted: "Урок успешно удален",
    audioDeleted: "Аудио успешно удалено",
    attachmentDeleted: "Вложение успешно удалено",
    exerciseDeleted: "Упражнение успешно удалено",
    exerciseSaved: "Упражнение успешно сохранено",
    lessonCreated: "Урок успешно создан",
    quizDeleted: "Тест успешно удален",
    quizUnlinked: "Тест успешно отвязан",
    quizCreated: "Тест успешно создан",
  },
  buttons: {
    cancel: "Отмена",
    ignore: "Игнорировать",
    ok: "OK",
    delete: "Удалить",
    unlink: "Отвязать",
    create: "Создать",
    save: "Сохранить",
    update: "Обновить",
    check: "Проверить",
    link: "Ссылка",
    submit: "Отправить",
    confirm: "Подтвердить",
    quit: "Выйти",
    back: "Назад",
    previous: "Предыдущий",
    next: "Далее",
    preview: "Предпросмотр",
    edit: "Редактировать",
    view: "Просмотр",
    join: "Присоединиться",
    close: "Закрыть",
  },
  editor: {
    enterUrl: "Введите URL",
    enterImageUrl: "Введите URL изображения",
    enterVideoUrl: "Введите URL видео",
    unlink: "Отвязать",
    link: "Ссылка",
    add: "Добавить",
    title: "Заголовок",
    submit: "Отправить",
    cancel: "Отмена",
  },
  common: {
    all: "Все",
    confirmDialog: "Вы уверены, что хотите выполнить эту операцию?",
  },
  date: {
    months: {
      short: [
        "Янв",
        "Фев",
        "Мар",
        "Апр",
        "Май",
        "Июн",
        "Июл",
        "Авг",
        "Сен",
        "Окт",
        "Ноя",
        "Дек",
      ],
      full: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
    },
  },
  fileBrowser: {
    delete: {
      title: "Удалить",
      description:
        "Вы уверены, что хотите удалить этот <b>{type}</b>?<br><em>{baseName}</em>",
      suffix: {
        folder: "папка",
        file: "Файл",
      },
    },
    cancel: "Отмена",
    select: "Выбрать",
    yes: "Да",
    selectFolderOrFile: "Выберите папку или файл",
    file: "Файл",
    size: "Размер",
    noFilesOrFoldersFound: "Файлы или папки не найдены",
    folderIsEmpty: "Папка пуста",
    upTo: "До: {value}",
    createFolder: "Создать папку",
    uploadFiles: "Загрузить файлы",
    collapseAll: "Свернуть все",
    uploadTo: "Загрузить в:",
    maxFilesCount: "Максимальное количество файлов: {value}",
    maxFileSize: "Максимальный размер файла: {value}",
    addFiles: "Добавить файлы",
    clear: "Очистить",
    upload: "Загрузить",
  },
  camera: {
    errors: {
      CAMERA_IS_OFF: {
        title: "Камера выключена",
      },
      CAMERA_PERMISSION_ERROR: {
        title: "Не предоставлены разрешения на камеру",
        description:
          "Чтобы исправить эту проблему, пожалуйста, предоставьте доступ в вашем браузере и перезагрузите страницу",
      },
      CAMERA_UNAVAILABLE_ERROR: {
        title: "Камера недоступна",
        description:
          "Во время запроса доступа к камере браузер не смог предоставить доступ к камере",
      },
      MIC_PERMISSION_ERROR: {
        title: "Не предоставлены разрешения на микрофон",
        description:
          "Чтобы исправить эту проблему, пожалуйста, предоставьте доступ в вашем браузере и перезагрузите страницу",
      },
      MIC_UNAVAILABLE_ERROR: {
        title: "Микрофон недоступен",
        description:
          "Во время запроса доступа к микрофону браузер не смог предоставить доступ к микрофону",
      },
    },
  },
  time: {
    startsIn: "Начинается через <b>{time}</b>",
    endsIn: "Заканчивается через <b>{time}</b>",
    ended: "Закончился в <b>{time}</b>",
    cancelled: "Отменен в <b>{time}</b>",
  },
};
